import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/assets/config/config/app-config';

@Injectable({ providedIn: 'root' })
export class GenAIService {
    apiUrl:String = null;
    genAIUrl:String = null;

    constructor(
    private http: HttpClient,    
    private config: AppConfig
    ) {
        this.apiUrl = this.config.getConfig('apiUrl');
        this.genAIUrl = this.config.getConfig('genAIEndpoint');
    }

    qnaQueryExecutionHandler(query){
        const payload = {query: query}
        let url = `${this.genAIUrl}/qna/search`
        return this.http.post<any>(url, payload).pipe()
        //return {score:90, answer:"test"}
    }

    qnaQueryAnthropicExecutionHandler(query){
        let url = `${this.genAIUrl}/qna/document/anthropic`
        return this.http.post<any>(url, query).pipe()
        //return {score:90, answer:"test"}
    }

    chatQueryExecutionHandler(query, categories, llm){        
        const payload = {query: query, categories:categories}
        let url = `${this.genAIUrl}/chat/${llm}`
        return this.http.post<any>(url, payload).pipe()
    }

    similarityQueryExecutionHandler(query, categories){
        const payload = {query: query, categories: categories}
        let url = `${this.genAIUrl}/similarity-search`
        return this.http.post<any>(url, payload).pipe()
    }

}